package io.github.dautovicharis.charts.app.ui.theme

import androidx.compose.ui.graphics.Color

class ThemeColors(
    val md_theme_light_primary: Color,
    val md_theme_light_onPrimary: Color,
    val md_theme_light_primaryContainer: Color,
    val md_theme_light_onPrimaryContainer: Color,
    val md_theme_light_secondary: Color,
    val md_theme_light_onSecondary: Color,
    val md_theme_light_secondaryContainer: Color,
    val md_theme_light_onSecondaryContainer: Color,
    val md_theme_light_tertiary: Color,
    val md_theme_light_onTertiary: Color,
    val md_theme_light_tertiaryContainer: Color,
    val md_theme_light_onTertiaryContainer: Color,
    val md_theme_light_error: Color,
    val md_theme_light_errorContainer: Color,
    val md_theme_light_onError: Color,
    val md_theme_light_onErrorContainer: Color,
    val md_theme_light_background: Color,
    val md_theme_light_onBackground: Color,
    val md_theme_light_surface: Color,
    val md_theme_light_onSurface: Color,
    val md_theme_light_surfaceVariant: Color,
    val md_theme_light_onSurfaceVariant: Color,
    val md_theme_light_outline: Color,
    val md_theme_light_inverseOnSurface: Color,
    val md_theme_light_inverseSurface: Color,
    val md_theme_light_inversePrimary: Color,
    val md_theme_light_shadow: Color,
    val md_theme_light_surfaceTint: Color,
    val md_theme_light_outlineVariant: Color,
    val md_theme_light_scrim: Color,
    val md_theme_dark_primary: Color,
    val md_theme_dark_onPrimary: Color,
    val md_theme_dark_primaryContainer: Color,
    val md_theme_dark_onPrimaryContainer: Color,
    val md_theme_dark_secondary: Color,
    val md_theme_dark_onSecondary: Color,
    val md_theme_dark_secondaryContainer: Color,
    val md_theme_dark_onSecondaryContainer: Color,
    val md_theme_dark_tertiary: Color,
    val md_theme_dark_onTertiary: Color,
    val md_theme_dark_tertiaryContainer: Color,
    val md_theme_dark_onTertiaryContainer: Color,
    val md_theme_dark_error: Color,
    val md_theme_dark_errorContainer: Color,
    val md_theme_dark_onError: Color,
    val md_theme_dark_onErrorContainer: Color,
    val md_theme_dark_background: Color,
    val md_theme_dark_onBackground: Color,
    val md_theme_dark_surface: Color,
    val md_theme_dark_onSurface: Color,
    val md_theme_dark_surfaceVariant: Color,
    val md_theme_dark_onSurfaceVariant: Color,
    val md_theme_dark_outline: Color,
    val md_theme_dark_inverseOnSurface: Color,
    val md_theme_dark_inverseSurface: Color,
    val md_theme_dark_inversePrimary: Color,
    val md_theme_dark_shadow: Color,
    val md_theme_dark_surfaceTint: Color,
    val md_theme_dark_outlineVariant: Color,
    val md_theme_dark_scrim: Color,
    val seed: Color
)


val deepOceanBlue = ThemeColors(
    // Light Theme Colors
    md_theme_light_primary = Color(0xFF006590),
    md_theme_light_onPrimary = Color(0xFFFFFFFF),
    md_theme_light_primaryContainer = Color(0xFFC8E6FF),
    md_theme_light_onPrimaryContainer = Color(0xFF001E2E),
    md_theme_light_secondary = Color(0xFF9E3776),
    md_theme_light_onSecondary = Color(0xFFFFFFFF),
    md_theme_light_secondaryContainer = Color(0xFFFFD8E9),
    md_theme_light_onSecondaryContainer = Color(0xFF3C0029),
    md_theme_light_tertiary = Color(0xFF845400),
    md_theme_light_onTertiary = Color(0xFFFFFFFF),
    md_theme_light_tertiaryContainer = Color(0xFFFFDDB6),
    md_theme_light_onTertiaryContainer = Color(0xFF2A1800),
    md_theme_light_error = Color(0xFFBA1A1A),
    md_theme_light_errorContainer = Color(0xFFFFDAD6),
    md_theme_light_onError = Color(0xFFFFFFFF),
    md_theme_light_onErrorContainer = Color(0xFF410002),
    md_theme_light_background = Color(0xFFFCFCFF),
    md_theme_light_onBackground = Color(0xFF191C1E),
    md_theme_light_surface = Color(0xFFFCFCFF),
    md_theme_light_onSurface = Color(0xFF191C1E),
    md_theme_light_surfaceVariant = Color(0xFFDDE3EA),
    md_theme_light_onSurfaceVariant = Color(0xFF41484D),
    md_theme_light_outline = Color(0xFF71787E),
    md_theme_light_inverseOnSurface = Color(0xFFF0F0F3),
    md_theme_light_inverseSurface = Color(0xFF2E3133),
    md_theme_light_inversePrimary = Color(0xFF88CEFF),
    md_theme_light_shadow = Color(0xFF000000),
    md_theme_light_surfaceTint = Color(0xFF006590),
    md_theme_light_outlineVariant = Color(0xFFC1C7CE),
    md_theme_light_scrim = Color(0xFF000000),
    // Dark Theme Colors
    md_theme_dark_primary = Color(0xFF88CEFF),
    md_theme_dark_onPrimary = Color(0xFF00344D),
    md_theme_dark_primaryContainer = Color(0xFF004C6D),
    md_theme_dark_onPrimaryContainer = Color(0xFFC8E6FF),
    md_theme_dark_secondary = Color(0xFFFFAFD8),
    md_theme_dark_onSecondary = Color(0xFF610044),
    md_theme_dark_secondaryContainer = Color(0xFF801D5D),
    md_theme_dark_onSecondaryContainer = Color(0xFFFFD8E9),
    md_theme_dark_tertiary = Color(0xFFFFB95A),
    md_theme_dark_onTertiary = Color(0xFF462A00),
    md_theme_dark_tertiaryContainer = Color(0xFF643F00),
    md_theme_dark_onTertiaryContainer = Color(0xFFFFDDB6),
    md_theme_dark_error = Color(0xFFFFB4AB),
    md_theme_dark_errorContainer = Color(0xFF93000A),
    md_theme_dark_onError = Color(0xFF690005),
    md_theme_dark_onErrorContainer = Color(0xFFFFDAD6),
    md_theme_dark_background = Color(0xFF191C1E),
    md_theme_dark_onBackground = Color(0xFFE2E2E5),
    md_theme_dark_surface = Color(0xFF191C1E),
    md_theme_dark_onSurface = Color(0xFFE2E2E5),
    md_theme_dark_surfaceVariant = Color(0xFF41484D),
    md_theme_dark_onSurfaceVariant = Color(0xFFC1C7CE),
    md_theme_dark_outline = Color(0xFF8B9198),
    md_theme_dark_inverseOnSurface = Color(0xFF191C1E),
    md_theme_dark_inverseSurface = Color(0xFFE2E2E5),
    md_theme_dark_inversePrimary = Color(0xFF006590),
    md_theme_dark_shadow = Color(0xFF000000),
    md_theme_dark_surfaceTint = Color(0xFF88CEFF),
    md_theme_dark_outlineVariant = Color(0xFF41484D),
    md_theme_dark_scrim = Color(0xFF000000),
    seed = Color(0xFF003F5C)
)

val blueViolet = ThemeColors(
    // Light Theme Colors
    md_theme_light_primary = Color(0xFF4858A9),
    md_theme_light_onPrimary = Color(0xFFFFFFFF),
    md_theme_light_primaryContainer = Color(0xFFDEE1FF),
    md_theme_light_onPrimaryContainer = Color(0xFF001159),
    md_theme_light_secondary = Color(0xFF8C4381),
    md_theme_light_onSecondary = Color(0xFFFFFFFF),
    md_theme_light_secondaryContainer = Color(0xFFFFD7F3),
    md_theme_light_onSecondaryContainer = Color(0xFF390035),
    md_theme_light_tertiary = Color(0xFF9B4053),
    md_theme_light_onTertiary = Color(0xFFFFFFFF),
    md_theme_light_tertiaryContainer = Color(0xFFFFD9DD),
    md_theme_light_onTertiaryContainer = Color(0xFF400014),
    md_theme_light_error = Color(0xFFBA1A1A),
    md_theme_light_errorContainer = Color(0xFFFFDAD6),
    md_theme_light_onError = Color(0xFFFFFFFF),
    md_theme_light_onErrorContainer = Color(0xFF410002),
    md_theme_light_background = Color(0xFFFEFBFF),
    md_theme_light_onBackground = Color(0xFF1B1B1F),
    md_theme_light_surface = Color(0xFFFEFBFF),
    md_theme_light_onSurface = Color(0xFF1B1B1F),
    md_theme_light_surfaceVariant = Color(0xFFE3E1EC),
    md_theme_light_onSurfaceVariant = Color(0xFF46464F),
    md_theme_light_outline = Color(0xFF767680),
    md_theme_light_inverseOnSurface = Color(0xFFF3F0F4),
    md_theme_light_inverseSurface = Color(0xFF303034),
    md_theme_light_inversePrimary = Color(0xFFBAC3FF),
    md_theme_light_shadow = Color(0xFF000000),
    md_theme_light_surfaceTint = Color(0xFF4858A9),
    md_theme_light_outlineVariant = Color(0xFFC6C5D0),
    md_theme_light_scrim = Color(0xFF000000),
    // Dark Theme Colors
    md_theme_dark_primary = Color(0xFFBAC3FF),
    md_theme_dark_onPrimary = Color(0xFF152778),
    md_theme_dark_primaryContainer = Color(0xFF2F4090),
    md_theme_dark_onPrimaryContainer = Color(0xFFDEE1FF),
    md_theme_dark_secondary = Color(0xFFFFABED),
    md_theme_dark_onSecondary = Color(0xFF561250),
    md_theme_dark_secondaryContainer = Color(0xFF712B68),
    md_theme_dark_onSecondaryContainer = Color(0xFFFFD7F3),
    md_theme_dark_tertiary = Color(0xFFFFB2BD),
    md_theme_dark_onTertiary = Color(0xFF5F1127),
    md_theme_dark_tertiaryContainer = Color(0xFF7D293D),
    md_theme_dark_onTertiaryContainer = Color(0xFFFFD9DD),
    md_theme_dark_error = Color(0xFFFFB4AB),
    md_theme_dark_errorContainer = Color(0xFF93000A),
    md_theme_dark_onError = Color(0xFF690005),
    md_theme_dark_onErrorContainer = Color(0xFFFFDAD6),
    md_theme_dark_background = Color(0xFF1B1B1F),
    md_theme_dark_onBackground = Color(0xFFE4E1E6),
    md_theme_dark_surface = Color(0xFF1B1B1F),
    md_theme_dark_onSurface = Color(0xFFE4E1E6),
    md_theme_dark_surfaceVariant = Color(0xFF46464F),
    md_theme_dark_onSurfaceVariant = Color(0xFFC6C5D0),
    md_theme_dark_outline = Color(0xFF90909A),
    md_theme_dark_inverseOnSurface = Color(0xFF1B1B1F),
    md_theme_dark_inverseSurface = Color(0xFFE4E1E6),
    md_theme_dark_inversePrimary = Color(0xFF4858A9),
    md_theme_dark_shadow = Color(0xFF000000),
    md_theme_dark_surfaceTint = Color(0xFFBAC3FF),
    md_theme_dark_outlineVariant = Color(0xFF46464F),
    md_theme_dark_scrim = Color(0xFF000000),
    seed = Color(0xFF2F3C7E)
)

val deepRed = ThemeColors(
    // Light Theme Colors
    md_theme_light_primary = Color(0xFFB72030),
    md_theme_light_onPrimary = Color(0xFFFFFFFF),
    md_theme_light_primaryContainer = Color(0xFFFFDAD8),
    md_theme_light_onPrimaryContainer = Color(0xFF410007),
    md_theme_light_secondary = Color(0xFF9C404A),
    md_theme_light_onSecondary = Color(0xFFFFFFFF),
    md_theme_light_secondaryContainer = Color(0xFFFFDADB),
    md_theme_light_onSecondaryContainer = Color(0xFF40000D),
    md_theme_light_tertiary = Color(0xFF9B4055),
    md_theme_light_onTertiary = Color(0xFFFFFFFF),
    md_theme_light_tertiaryContainer = Color(0xFFFFD9DE),
    md_theme_light_onTertiaryContainer = Color(0xFF3F0015),
    md_theme_light_error = Color(0xFFBA1A1A),
    md_theme_light_errorContainer = Color(0xFFFFDAD6),
    md_theme_light_onError = Color(0xFFFFFFFF),
    md_theme_light_onErrorContainer = Color(0xFF410002),
    md_theme_light_background = Color(0xFFFFFBFF),
    md_theme_light_onBackground = Color(0xFF201A1A),
    md_theme_light_surface = Color(0xFFFFFBFF),
    md_theme_light_onSurface = Color(0xFF201A1A),
    md_theme_light_surfaceVariant = Color(0xFFF4DDDC),
    md_theme_light_onSurfaceVariant = Color(0xFF524342),
    md_theme_light_outline = Color(0xFF857372),
    md_theme_light_inverseOnSurface = Color(0xFFFBEEED),
    md_theme_light_inverseSurface = Color(0xFF362F2E),
    md_theme_light_inversePrimary = Color(0xFFFFB3B1),
    md_theme_light_shadow = Color(0xFF000000),
    md_theme_light_surfaceTint = Color(0xFFB72030),
    md_theme_light_outlineVariant = Color(0xFFD7C1C0),
    md_theme_light_scrim = Color(0xFF000000),
    // Dark Theme Colors
    md_theme_dark_primary = Color(0xFFFFB3B1),
    md_theme_dark_onPrimary = Color(0xFF680011),
    md_theme_dark_primaryContainer = Color(0xFF92001D),
    md_theme_dark_onPrimaryContainer = Color(0xFFFFDAD8),
    md_theme_dark_secondary = Color(0xFFFFB2B6),
    md_theme_dark_onSecondary = Color(0xFF5F121F),
    md_theme_dark_secondaryContainer = Color(0xFF7D2934),
    md_theme_dark_onSecondaryContainer = Color(0xFFFFDADB),
    md_theme_dark_tertiary = Color(0xFFFFB2BE),
    md_theme_dark_onTertiary = Color(0xFF5F1128),
    md_theme_dark_tertiaryContainer = Color(0xFF7D293E),
    md_theme_dark_onTertiaryContainer = Color(0xFFFFD9DE),
    md_theme_dark_error = Color(0xFFFFB4AB),
    md_theme_dark_errorContainer = Color(0xFF93000A),
    md_theme_dark_onError = Color(0xFF690005),
    md_theme_dark_onErrorContainer = Color(0xFFFFDAD6),
    md_theme_dark_background = Color(0xFF201A1A),
    md_theme_dark_onBackground = Color(0xFFEDE0DF),
    md_theme_dark_surface = Color(0xFF201A1A),
    md_theme_dark_onSurface = Color(0xFFEDE0DF),
    md_theme_dark_surfaceVariant = Color(0xFF524342),
    md_theme_dark_onSurfaceVariant = Color(0xFFD7C1C0),
    md_theme_dark_outline = Color(0xFFA08C8B),
    md_theme_dark_inverseOnSurface = Color(0xFF201A1A),
    md_theme_dark_inverseSurface = Color(0xFFEDE0DF),
    md_theme_dark_inversePrimary = Color(0xFFB72030),
    md_theme_dark_shadow = Color(0xFF000000),
    md_theme_dark_surfaceTint = Color(0xFFFFB3B1),
    md_theme_dark_outlineVariant = Color(0xFF524342),
    md_theme_dark_scrim = Color(0xFF000000),
    seed = Color(0xFFCC313D)
)
